<section class="summary-panel" *ngIf="summary$ | async as summary">
  <header class="summary-panel__header">
    <div class="summary-panel__title-group">
      <h2 class="summary-panel__title">{{ textService.getText('apps_summary_headline') }}</h2>
    </div>

    <span class="summary-panel__badge" *ngIf="showHeaderBadge(summary)">
      ${{ formatPrice(getBadgeTotal(summary)) }}
      <span class="summary-panel__badge-label" *ngIf="showDueTodayBadge(summary)">
        {{ textService.getText('summary_due_today') }}
      </span>
      <span class="summary-panel__badge-label" *ngIf="showMonthlyBadge(summary)">
        {{ textService.getText('summary_per_month') }}
      </span>
      <span class="summary-panel__badge-label" *ngIf="showAnnualBadge(summary)">
        {{ textService.getText('summary_per_year') }}
      </span>
    </span>
  </header>

  <ng-container *ngIf="summary.items.length > 0; else emptyState">
    <ng-container *ngIf="isO365Flow(); else defaultSummaryLayout">
      <ul class="summary-lines summary-lines--cart">
        <li
          *ngFor="let group of getGroupedMonthlyItems(summary); trackBy: trackCartGroup"
          class="summary-group summary-group--cart"
          [class.summary-group--has-addons]="group.addons.length > 0">
          <div class="summary-line summary-line--primary">
            <div class="summary-line__info">
              <p class="summary-line__name">{{ group.product.name }}</p>

              <div class="summary-line__meta">
                <span
                  class="summary-tag summary-tag--annual"
                  *ngIf="group.product.billingCycle === 'annual'">
                  {{ textService.getText('annual_commitment') }}
                </span>
                <span
                  class="summary-tag summary-tag--monthly"
                  *ngIf="group.product.commitment === 'monthly' && group.product.billingCycle !== 'annual'">
                  {{ textService.getText('monthly_commitment') }}
                </span>
              </div>
            </div>

            <div class="summary-line__qty">
              <input
                type="number"
                min="1"
                max="99"
                class="summary-line__qty-input summary-line__qty-input--readonly"
                [class.is-invalid]="hasInvalidCartLine(group.product.cartLineId!)"
                [ngModel]="group.product.quantity"
                [name]="'cart-qty-' + group.product.cartLineId"
                readonly
                tabindex="-1"
                aria-readonly="true"
              />
            </div>

            <div class="summary-line__price">${{ formatPrice(group.product.unitPrice) }}</div>

            <div class="summary-line__actions">
              <button
                type="button"
                class="summary-line__remove"
                (click)="removeCartLine(group.product.cartLineId!, $event)"
                [attr.aria-label]="textService.getText('summary_remove_item')"
                [attr.title]="textService.getText('summary_remove_item')">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>

          <ul class="summary-group__addons" *ngIf="group.addons.length">
            <li
              *ngFor="let addonGroup of getCartAddonGroups(group); let groupIndex = index; trackBy: trackCartAddonGroup"
              class="summary-addon-group"
            >
              <ul class="summary-addon-group__list">
                <li
                  *ngFor="let addon of addonGroup.items; let addonIndex = index"
                  class="summary-line summary-line--nested-addon"
                  [class.summary-line--nested-last]="isLastCartAddon(group, groupIndex, addonIndex)"
                >
              <div class="summary-line__info">
                <p class="summary-line__name">{{ addon.name }}</p>

                <div class="summary-line__meta">
                  <span
                    class="summary-tag summary-tag--addon"
                    [class.summary-tag--monthly]="addon.billingCycle !== 'annual'"
                    [class.summary-tag--annual]="addon.billingCycle === 'annual'">
                    {{
                      addon.billingCycle === 'annual'
                        ? textService.getText('summary_addon_annual_commitment')
                        : textService.getText('summary_addon_monthly_commitment')
                    }}
                  </span>
                </div>
              </div>

              <div class="summary-line__qty">
                <input
                  type="number"
                  min="1"
                  [attr.max]="getCartAddonMaxQuantity(group.product.cartLineId!, addon)"
                  class="summary-line__qty-input summary-line__qty-input--compact summary-line__qty-input--readonly"
                  [class.is-invalid]="hasInvalidCartAddon(group.product.cartLineId!, addon)"
                  [ngModel]="addon.quantity"
                  [name]="'cart-addon-qty-' + group.product.cartLineId + '-' + getAddonProductId(addon)"
                  readonly
                  tabindex="-1"
                  aria-readonly="true"
                />
              </div>

              <div class="summary-line__price">${{ formatPrice(addon.unitPrice) }}</div>

              <div class="summary-line__actions">
                <button
                  type="button"
                  class="summary-line__remove summary-line__remove--compact"
                  (click)="removeCartAddon(group.product.cartLineId!, addon, $event)"
                  [attr.aria-label]="textService.getText('summary_remove_item')"
                  [attr.title]="textService.getText('summary_remove_item')">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
                </li>
              </ul>
            </li>
          </ul>

          <p
            *ngIf="group.addons.length && hasInvalidCartAddonGroup(group.product.cartLineId!)"
            class="summary-line__group-error">
            {{ textService.getText('o365_addon_quantity_exceeds_parent') }}
          </p>
        </li>
      </ul>

      <div
        class="summary-license-total"
        [class.is-invalid]="hasO365TotalLicenseLimitExceeded(summary)">
        <span class="summary-license-total__label">
          {{ textService.getText('o365_max_total_quantity') }}
        </span>
        <span class="summary-license-total__value">
          {{ summary.quantity }} / {{ o365MaxLicenses }}
        </span>
      </div>

      <p
        *ngIf="hasO365TotalLicenseLimitExceeded(summary)"
        class="summary-license-total__error">
        {{ textService.getText('o365_max') }}
      </p>

      <div class="summary-totals">
        <ng-container *ngTemplateOutlet="summaryTotals; context: { $implicit: summary }"></ng-container>
      </div>
    </ng-container>

    <ng-template #defaultSummaryLayout>
    <div class="summary-card">
      <div class="summary-card__columns" aria-hidden="true">
        <span>{{ textService.getText('item') }}</span>
        <span>{{ textService.getText('quantity') }}</span>
        <span>{{ textService.getText('price') }}</span>
      </div>

      <ul class="summary-lines">
        <li
          *ngFor="let group of getGroupedMonthlyItems(summary)"
          class="summary-group"
          [class.summary-group--standalone-addon]="isStandaloneAddonGroup(group)">
          <div
            class="summary-line"
            [class.summary-line--product]="!isStandaloneAddonGroup(group)"
            [class.summary-line--addon]="isStandaloneAddonGroup(group)">
            <div class="summary-line__info">
              <p class="summary-line__name">{{ group.product.name }}</p>

              <div class="summary-line__meta">
                <span class="summary-tag summary-tag--addon" *ngIf="isStandaloneAddonGroup(group)">
                  {{ textService.getText('summary_addon_badge') }}
                </span>
                <span
                  class="summary-tag summary-tag--annual"
                  *ngIf="group.product.billingCycle === 'annual'">
                  {{ textService.getText('annual_commitment') }}
                </span>
              </div>
            </div>

            <div class="summary-line__qty">{{ group.product.quantity }}</div>
            <div class="summary-line__price">${{ formatPrice(group.product.unitPrice) }}</div>
          </div>

          <ul class="summary-group__addons" *ngIf="group.addons.length">
            <li
              *ngFor="let addon of group.addons"
              class="summary-line summary-line--addon summary-line--nested">
              <div class="summary-line__info">
                <p class="summary-line__name">{{ addon.name }}</p>

                <div class="summary-line__meta">
                  <span class="summary-tag summary-tag--addon">
                    {{ textService.getText('summary_addon_badge') }}
                  </span>
                  <span
                    class="summary-tag summary-tag--annual"
                    *ngIf="addon.billingCycle === 'annual'">
                    {{ textService.getText('annual_commitment') }}
                  </span>
                </div>
              </div>

              <div class="summary-line__qty">{{ addon.quantity }}</div>
              <div class="summary-line__price">${{ formatPrice(addon.unitPrice) }}</div>
            </li>
          </ul>
        </li>
      </ul>

      <ng-container *ngTemplateOutlet="summaryTotals; context: { $implicit: summary }"></ng-container>
    </div>
    </ng-template>

    <ng-template #summaryTotals let-summary>
      <ng-container *ngIf="isO365Flow(); else defaultSummaryTotals">
        <div class="summary-total summary-total--due-today">
          <span class="summary-total__label">{{ textService.getText('summary_order_total') }}</span>
          <span class="summary-total__value">
            ${{ formatPrice(getO365DisplayDueTodayTotal(summary)) }}<span *ngIf="hasO365MinimumMonthlySpend(summary)">*</span>
          </span>
        </div>

        <p
          *ngIf="hasO365MinimumMonthlySpend(summary)"
          class="summary-footnote">
          {{ textService.getText('o365_minimum_monthly_spend_note') }}
        </p>
      </ng-container>

      <ng-template #defaultSummaryTotals>
      <ng-container *ngIf="hasMixedBilling(summary); else singleBillingTotal">
        <div class="summary-total summary-total--breakdown">
          <span class="summary-total__label">{{ textService.getText('monthly_total') }}</span>
          <span class="summary-total__value">
            ${{ formatPrice(getDisplayMonthlyTotal(summary)) }}
          </span>
        </div>

        <div class="summary-total summary-total--breakdown">
          <span class="summary-total__label">{{ textService.getText('annual_total') }}</span>
          <span class="summary-total__value">${{ formatPrice(getAnnualUpfrontTotal(summary)) }}</span>
        </div>

        <div class="summary-total summary-total--due-today">
          <span class="summary-total__label">{{ textService.getText('summary_total_due_today') }}</span>
          <span class="summary-total__value">${{ formatPrice(getDueTodayTotal(summary)) }}</span>
        </div>
      </ng-container>

      <ng-template #singleBillingTotal>
        <div class="summary-total" *ngIf="hasMonthlyBillingItems(summary)">
          <span class="summary-total__label">{{ textService.getText('monthly_total') }}</span>
          <span class="summary-total__value">
            ${{ formatPrice(getDueTodayTotal(summary)) }}
          </span>
        </div>

        <div class="summary-total summary-total--secondary" *ngIf="hasAnnualUpfrontItems(summary)">
          <span class="summary-total__label">{{ textService.getText('annual_total') }}</span>
          <span class="summary-total__value">${{ formatPrice(getDueTodayTotal(summary)) }}</span>
        </div>
      </ng-template>
      </ng-template>
    </ng-template>

    <div class="summary-card summary-card--domain" *ngIf="hasDomainItems(summary)">
      <h3 class="summary-card__section-title">
        {{ textService.getText('apps_domain_summary_headline') }}
      </h3>

      <div class="summary-card__columns" aria-hidden="true">
        <span>{{ textService.getText('item') }}</span>
        <span>{{ textService.getText('term') }}</span>
        <span>{{ textService.getText('price') }}</span>
      </div>

      <ul class="summary-lines">
        <li *ngFor="let domain of getDomainItems(summary)" class="summary-line">
          <div class="summary-line__info">
            <p class="summary-line__name">{{ domain.name }}</p>
          </div>
          <div class="summary-line__qty">1 {{ textService.getText('domain_registration_length') }}</div>
          <div class="summary-line__price">${{ formatPrice(domain.unitPrice) }}</div>
        </li>
      </ul>

      <div class="summary-total summary-total--secondary">
        <span class="summary-total__label">{{ textService.getText('annual_total') }}</span>
        <span class="summary-total__value">${{ formatPrice(getDomainTotal(summary)) }}</span>
      </div>

      <p class="summary-notice">{{ textService.getText('domain_charge_notice') }}</p>
    </div>

    <div class="summary-notes">
      <ng-container *ngIf="isAppsFlow(); else o365Notes">
        <div class="summary-note">
          <svg class="summary-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
          <p [innerHTML]="textService.getText('apps_summary_trial_period_without_date')"></p>
        </div>

        <div class="summary-note">
          <svg class="summary-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <rect x="2" y="5" width="20" height="14" rx="2"></rect>
            <path d="M2 10h20"></path>
          </svg>
          <p [innerHTML]="textService.getText('single_payment_method_email')"></p>
        </div>
      </ng-container>

      <ng-template #o365Notes>
        <div class="summary-note">
          <svg class="summary-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
          <p [innerHTML]="textService.getText('summary_annual_disclaimer')"></p>
        </div>

        <div class="summary-note">
          <svg class="summary-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
          <p [innerHTML]="textService.getText('o365_summary_annual_commit')"></p>
        </div>

        <div class="summary-note">
          <svg class="summary-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4"></path>
            <path d="M12 8h.01"></path>
          </svg>
          <p [innerHTML]="textService.getText('apps_summary_trial_period_without_date')"></p>
        </div>

        <div class="summary-note">
          <svg class="summary-note__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <rect x="2" y="5" width="20" height="14" rx="2"></rect>
            <path d="M2 10h20"></path>
          </svg>
          <p [innerHTML]="textService.getText('single_payment_method')"></p>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div class="summary-empty">
      <div class="summary-empty__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M6 6h15l-1.5 9h-12z"></path>
          <path d="M6 6l-1.5-3H2"></path>
          <circle cx="9" cy="20" r="1"></circle>
          <circle cx="18" cy="20" r="1"></circle>
        </svg>
      </div>
      <p class="summary-empty__title">{{ getPlaceholderText() }}</p>
      <p class="summary-empty__hint">{{ textService.getText('apps_summary_commitment') }}</p>
    </div>
  </ng-template>
</section>
